module.exports = __webpack_public_path__ + "img/253b3975858734b560304a1898ae2b54.3330c7f6.png";